<template>
  <div>
    <TextHeader :title="header" />
    <PageParagraph
      :title="title"
      :sideTitle="titleSide"
      :height="height"
      @onclickTitle="NavigateToSection"
    >
      <div
        class="paragraph"
        v-for="(item, i) in contents"
        :key="i"
        :id="item.primary.id[0].text"
      >
        <TextTitle
          :inLine="true"
          v-if="item.primary.title"
          :title="item.primary.title[0].text"
          fontWeight="600"
          :subTitle="true"
        />
        <component :is="item.slice_type" :content="item" />
      </div>
    </PageParagraph>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  components: {
    TextHeader: () => import(`@/components/TextHeader`),
    PageParagraph: () => import(`@/components/PageParagraph`),
    TextTitle: () => import(`@/components/TextTitle`),
    Partner: () => import(`@/components/Partner`),
    ContentIcon: () => import(`@/components/study/ContentIcon`),
    ContentVideo: () => import(`@/components/study/ContentVideo`),
    ContentSection: () => import(`@/components/study/ContentSection`),
    ContentParagraph: () => import(`@/components/study/ContentParagraph`),
  },
  data() {
    return {
      title: [],
      contents: null,
      titleSide: null,
      header: null,
      height: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  watch: {
    language() {
      this.getAboutParagraph();
    },
  },
  mounted() {
    this.getAboutParagraph();
  },
  methods: {
    async getAboutParagraph() {
      this.title = [];
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["StudyOverview","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.contents = res.data.results[0].data.body;
      this.header = res.data.results[0].data.name[0].text;
      this.titleSide = res.data.results[0].data.title_side[0].text;
      const me = this;
      this.contents.forEach((arr) => {
        console.log("arr.primary ", arr.primary);
        this.title.push(arr.primary.title_side[0].text);
        if (arr.slice_type === "study_content_1") {
          arr.slice_type = "ContentIcon";
        } else if (arr.slice_type === "study_content_2") {
          arr.slice_type = "ContentVideo";
        } else if (arr.slice_type === "study_content_3") {
          arr.slice_type = "ContentSection";
        } else if (arr.slice_type === "study_content_4") {
          arr.slice_type = "ContentParagraph";
        } else {
          arr.slice_type = null;
        }
      });
      const lastData = this.contents[this.contents.length - 1].primary.id[0]
        .text;
      const interval = setInterval(() => {
        if ($(`#${lastData}`).length > 0) {
          me.height = $(`#${lastData}`).outerHeight();
          clearInterval(interval);
        }
      }, 500);
    },
    NavigateToSection(index) {
      const id = this.contents[index].primary.id[0].text;
      console.log($(`#${id}`).offset().top);
      $("html, body").animate(
        { scrollTop: $(`#${id}`).offset().top - 106 },
        1000
      );
    },
  },
};
</script>
<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
<style scoped>
.title-section {
  padding: 20px 0;
  cursor: pointer;
  text-align: left;
}
.mist-h4 {
  font-weight: 600;
}
.mist-p {
  padding: 30px 0 0;
}
.img-about {
  max-height: 425.54px;
  width: 100%;
}
.paragraph {
  padding-top: 53px;
}
@media (max-width: 768px) {
  .paragraph {
    padding-top: 40px;
  }
}
</style>